module.exports = __webpack_public_path__ + "static/media/farm_5_auth_bg.8ef6cb85.png";